import { withRequiredPermissions } from '@/lib/permissions'
import { ClaimPhotoReport } from '@eigtech/ui-shared-claims'
import { createFileRoute, useNavigate } from '@tanstack/react-router'
import { ROUTER_PATHS } from '../../../../../lib/constants'

const ClaimDetailPhotoReport = withRequiredPermissions(ClaimPhotoReportComponent, {
  requiredPermissions: [
    { action: 'read', subject: 'document' },
    { action: 'create', subject: 'document' },
  ],
})

export const Route = createFileRoute('/_auth/claims/$claimNumber/_layout/photo-report')({
  component: ClaimDetailPhotoReport,
})

function ClaimPhotoReportComponent() {
  const { claimNumber } = Route.useParams()
  const navigate = useNavigate()

  return (
    <ClaimPhotoReport
      claimNumber={claimNumber}
      onSubmitted={() =>
        navigate({
          to: ROUTER_PATHS.claimDetailPhotoReportStatus.route,
          params: { claimNumber },
        })
      }
    />
  )
}
